'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var fetch = _interopDefault(require('unfetch'));
var reactErrorBoundary = require('react-error-boundary');
var url = require('@zillow/url');

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Get GA data from tracker
 * @returns {Object}
 */
var getGAData = function getGAData() {
  var ga = window.ga;
  var gaData = {};

  if (ga) {
    ga(function (tracker) {
      if (tracker.b && tracker.b.data) {
        var dataKeys = tracker.b.data.keys;
        dataKeys.forEach(function (key) {
          gaData[key] = tracker.get(key);
        });
      }
    });
  }

  return gaData;
};
/**
 * Get network information data
 * @returns {Object}
 */

var getConnectionData = function getConnectionData() {
  var connection = global.navigator.connection || global.navigator.mozConnection || global.navigator.webkitConnection;

  if (connection) {
    //we can destructure connection as it isn't a plain object but a NetworkInformation interface
    return {
      downlink: connection.downlink,
      downlinkMax: connection.downlinkMax,
      effectiveType: connection.effectiveType,
      rtt: connection.rtt,
      type: connection.type
    };
  }

  return {};
};
/**
 * Get the local date in ISO format
 */

var getLocalISODate = function getLocalISODate() {
  var date = new Date();
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
};
/**
 * Check if object is empty
 * @param {Object} obj
 * @returns {Boolean}
 */

var isObjectEmpty = function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$3.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$5.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = _createAssigner(function(object, source) {
  if (_isPrototype(source) || isArrayLike_1(source)) {
    _copyObject(source, keys_1(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty$6.call(source, key)) {
      _assignValue(object, key, source[key]);
    }
  }
});

var assign_1 = assign;

/* global window */
/* eslint
    no-underscore-dangle: off,
    no-var: off,
    prefer-rest-params: off,
    vars-on-top: off,
*/



var trackEvent = _trackEvent;
var trackPageView = _trackPageView;
var setCustomDimensions = _setCustomDimensions;
var shouldDispatchToNative_1 = shouldDispatchToNative;

function logError() {
    if (typeof window !== 'undefined' && window.console && window.console.error) {
        window.console.error.apply(console, arguments);
    }
}

// eslint-disable-next-line consistent-return
function _getMobNativeApi() {
    if (typeof window !== 'undefined' && window.ZMOB_nativeAPI) {
        return window.ZMOB_nativeAPI;
    }
}

var customDimensions = {};
function _setCustomDimensions(incomingCustomDimensions) {
    var coercedCustomDimensions = {};
    if (incomingCustomDimensions) {
        var keys = Object.keys(incomingCustomDimensions);
        // eslint-disable-next-line prefer-arrow-callback
        keys.forEach(function coerceDimension(element) {
            // remove dimension from the key
            // the iOS/Android client does not expect the leading qualifier in the string.
            // gross.
            var key = element.replace('dimension', '');
            coercedCustomDimensions[key] = incomingCustomDimensions[element];
        });
    }
    customDimensions = assign_1(customDimensions, coercedCustomDimensions);
}

function _getCustomDimensions(incomingCustomDimensions) {
    var currentCustomDimensions = customDimensions;
    if (incomingCustomDimensions) {
        currentCustomDimensions = assign_1(currentCustomDimensions, incomingCustomDimensions);
    }
    var keys = Object.keys(currentCustomDimensions);
    var slashStrippedCustomDimensions = {};
    // eslint-disable-next-line prefer-arrow-callback
    keys.forEach(function coerceDimension(element) {
        var key = _stripSlashes(element);
        var value = _stripSlashes(currentCustomDimensions[element]);
        slashStrippedCustomDimensions[key] = value;
    });
    return slashStrippedCustomDimensions;
}

/**
 * Overrides the call to GA with a
 * call to the native iOS and android
 * tracking method
 *
 * @method trackEvent
 * @private
 * @param {object} config
 */
function _trackEvent(config) {
    var category = _stripSlashes(config.category);
    var action = _stripSlashes(config.action);
    var label = _stripSlashes(config.label);
    var value = parseInt(config.value, 10);
    var called;

    var mobNativeAPI = _getMobNativeApi();
    if (mobNativeAPI) {
        if (mobNativeAPI.trackUAWebviewEvent) {
            var nativeCustomDimensions = _getCustomDimensions(config.customDimensions);
            mobNativeAPI.trackUAWebviewEvent(
                category,
                action,
                label,
                value,
                JSON.stringify(nativeCustomDimensions)
            );
            called = true;
        } else if (mobNativeAPI.trackWebviewEvent) {
            mobNativeAPI.trackWebviewEvent(category, action, label, value);
            called = true;
        }
    }

    if (typeof config.hitCallback === 'function') {
        config.hitCallback();
    }

    if (!called) {
        logError('There was no native method for trackEvent');
    }
}

function _trackPageView(config) {
    var page = config.pageURL;
    var called;

    var mobNativeAPI = _getMobNativeApi();
    if (mobNativeAPI) {
        var nativeCustomDimensions = _getCustomDimensions(config.customDimensions);
        if (mobNativeAPI.trackUAPageview) {
            mobNativeAPI.trackUAPageview(page, JSON.stringify(nativeCustomDimensions));
            called = true;
        } else if (mobNativeAPI.trackWebviewPageView) {
            mobNativeAPI.trackWebviewPageView(page);
            called = true;
        }
    }

    if (typeof config.hitCallback === 'function') {
        config.hitCallback();
    }

    if (!called) {
        logError('There was no native method for trackPageView');
    }
}

/**
Removes '/' from analytics params (action, category, label).
Native analytics api uses '/' as a property delimeter. This ensures that arguments
passed to the native analytics api don't get borked due to the presence of a '/'.
See: HDP-5046
@method _stripSlashes
@param {String} field
@return field if it is a string.
@private
*/
function _stripSlashes(field) {
    if (typeof field !== 'string') {
        return undefined;
    }

    return field.replace(/\//g, '-');
}

/**
 * Determines if we should dispatch calls to the native api
 *
 * @method shouldDispatchToNative
 * @private
 */
function shouldDispatchToNative() {
    return !!_getMobNativeApi();
}

var nativeApi = {
	trackEvent: trackEvent,
	trackPageView: trackPageView,
	setCustomDimensions: setCustomDimensions,
	shouldDispatchToNative: shouldDispatchToNative_1
};

var trackEvent_1 = trackEvent$1;
var _globalName = 'ga';

function logInfo() {
    if (typeof window !== 'undefined' && window.console && window.console.info) {
        window.console.info.apply(console, arguments);
    }
}

function logWarn() {
    if (typeof window !== 'undefined' && window.console && window.console.warn) {
        window.console.warn.apply(console, arguments);
    }
}

/**
 * Check if href is a tel link
 *
 * @method _isTelLink
 * @private
 */
function _isTelLink(href) {
    return /^tel:/i.test(href);
}

/**
 * Get the global Google Analytics object. This is generally window.ga,
 * but the global may be renamed on domains other than zillow.com. For
 * that reason, it is important to only call UA functions through the
 * object returned by this function.
 *
 * @method getGA
 * @return {Object} The GA global object.
 */
function getGA() {
    return typeof window !== 'undefined' && window[_globalName];
}

/**
 * Test to see if Google Universal Analytics is initialized.
 *
 * @method isInitialized
 */
function isInitialized() {
    return isFunction_1(getGA());
}

/**
 * Guarded window.open redirect callback generator.
 *
 * @method _getRedirect
 * @param {Object} config
 * @param {String} config.href Redirect to URL after event fires
 * @param {String} config.target The URL target
 */
function _getRedirect(config) {
    if (typeof window !== 'undefined' && window.open) {
        return window.open.bind(window, config.href, config.target);
    }

    return logInfo.bind(null, 'ga redirect window.open("%s", "%s")', config.href, config.target);
}

/**
 * Extract the metrics and dimensions from the object provided to the track API
 * and inject the corresponding entries into the UA options provided.
 * @method _insertDimensionsAndMetrics
 * @private
 * @param {Object} googleOptions The options being prepared for a call to ga('send', ...)
 * @param {Object} trackingParams The options provided to the track...
 * API optionally containing dimensions/metrics objects
 */
function _insertDimensionsAndMetrics(googleOptions, trackingParams) {
    _insertEntries(googleOptions, 'dimension', trackingParams.dimensions);
    _insertEntries(googleOptions, 'metric', trackingParams.metrics);
}

/**
 * Add the values in the entries object to the UA options provided.
 * @method _insertEntries
 * @private
 * @param {Object} googleOptions The options being prepared for a call to ga('send', ...)
 * @param {String} prefix The type of option being added - 'dimension' | 'metric'
 * @param {Object} entries Mapping of int index to value for the dimension/metric to be set
 */
function _insertEntries(googleOptions, prefix, entries) {
    if (entries) {
        assign_1(googleOptions, Object.keys(entries).reduce(reducer, {}));
    }

    function reducer(acc, key) {
        // Convert key to a number (strings that aren't numbers result in NaN)
        var index = Number(key);

        // ensure index is a positive integer
        if (index > 0 && index === Math.floor(index)) {
            acc[prefix + index] = entries[key];
        } else {
            logWarn('Could not set UA option ' + prefix + key);
        }

        return acc;
    }
}

/**
 * Default analytics event tracking.
 * This may be overriden.
 *
 * @method _trackEvent
 * @private
 * @param {Object} config
 */
function _trackEvent$1(config) {
    var googleUAObj = {
        hitType: 'event',
        eventCategory: config.category,
        eventAction: config.action,
        eventLabel: config.label,
        eventValue: config.value,
        nonInteraction: config.noninteraction,
    };

    if (config.hitCallback) {
        googleUAObj.hitCallback = config.hitCallback;
    }

    if (isInitialized()) {
        _insertDimensionsAndMetrics(googleUAObj, config);
        logInfo('Sending event to UA: ', googleUAObj);
        getGA()('send', googleUAObj);
    } else {
        logInfo('Would send event to UA but none found: ', googleUAObj);
    }

    /*
    If zillow analytics tracking script is initialized,
    use that as well
    */
    if (isZillowAnalyticsInitialized()) {
        var zaObj = {
            category: config.category,
            action: config.action,
            label: config.label,
            value: config.value,
            nonInteraction: config.noninteraction,
        };
        _insertDimensionsAndMetrics(zaObj, config);
        getZA().track('event', zaObj);
    }
}

/**
 * Track a Goggle Analytics event
 * (<a href="https://zwiki.zillowgroup.net/display/uxdev/Google+Analytics">read more about the GA tracking</a>).
 *
 * ### Examples
 *
 *     import { trackEvent } from '@zillow/universal-analytics';
 *
 *     // Track an event
 *     trackEvent({
 *         category: 'Mortgages',
 *         action: 'Upsell clicked'
 *         label: 'Search results list'
 *     });
 *
 *     // Track an event and then redirect
 *     trackEvent({
 *         category: 'Mortgages',
 *         action: 'Upsell clicked'
 *         label: 'Search results list',
 *         href: 'http://www.zillow.com/mortgage-rates/'
 *     });
 *
 *     // Track an event and open url in a new window
 *     trackEvent({
 *         category: 'Mortgages',
 *         action: 'Upsell clicked'
 *         label: 'Search results list',
 *         href: 'http://www.zillow.com/mortgage-rates/',
 *         target: '_blank'
 *     });
 *
 * @method trackEvent
 * @param {Object} config
 * @param {String} config.category Event category
 * @param {String} config.action Event action
 * @param {String} [config.label] Event label
 * @param {Number} [config.value] Event value
 * @param {Boolean} [config.noninteraction] Noninteraction event
 * @param {String} [config.href] Redirect to URL after event fires
 * @param {String} [config.target] The URL target, default: '_self'
 */
function trackEvent$1(config) {
    // Handle href redirects
    if (config.href) {
        // eslint-disable-next-line no-param-reassign
        config.target = config.target || '_self';

        // Bind href and target to the open function so it can be used
        // with setTimeout.
        var redirect = _getRedirect(config);

        // Not necessary to wait for URLs opened in a new target, and
        // waiting will cause the URL to be opened in a window instead
        // of a tab because it is no longer "user-initiated".
        if (config.target === '_blank' || _isTelLink(config.href)) {
            redirect.call();
        } else if (isInitialized()) {
            // When GA is intitialized, the redirect will occur when the
            // hit callback is called (usually very fast). If for some
            // reason GA fails or is really slow, the timeout will
            // guarantee the redirect occurs in a timely manner.
            var timeout = setTimeout(redirect, 500);

            // eslint-disable-next-line no-param-reassign
            config.hitCallback = function callRedirect() {
                // Make sure to clear timeout as anchor hrefs do not
                // change the page.
                clearTimeout(timeout);
                redirect.call();
            };
        } else {
            // Old school redirect in case GA hasn't been initialized
            setTimeout(redirect, 100);
        }
    }

    // Category and action are required fields
    if (!config.category) {
        logWarn('trackEvent: missing category');
    } else if (!config.action) {
        logWarn('trackEvent: missing action');
    } else if (nativeApi.shouldDispatchToNative()) {
        nativeApi.trackEvent(config);
    } else {
        _trackEvent$1(config);
    }
}

/**
 * Find out if zillow analytics script is initialized
 * Also make sure that window.analytics is not a HTML element
 *
 * @method isZillowAnalyticsInitialized
 */
function isZillowAnalyticsInitialized() {
    return (
        typeof window !== 'undefined' &&
        typeof getZA() !== 'undefined' &&
        typeof getZA().nodeName === 'undefined'
    );
}

/**
 * Get the global Zillow Analytics object. This is generally window.analytics,
 * but the global may be renamed on domains other than zillow.com.
 *
 * @method getZA
 * @return {Object} The Zillow Analytics global object.
 */
function getZA() {
    return typeof window !== 'undefined' && window[window.ZillowAnalyticsObject];
}

var DEFAULT_CATEGORY = 'contextualBandit';
/**
 * Stringify JSON but catch the error just in case
 * @param {Object} jsonObj
 * @returns {String}
 */

var stringify = function stringify(jsonObj) {
  try {
    return JSON.stringify(jsonObj);
  } catch (e) {
    console.warn('JSON Parse Error', e);
    return '{}';
  }
};

var trackExposure = function trackExposure(_ref) {
  var experimentId = _ref.experimentId,
      _ref$abConfig = _slicedToArray(_ref.abConfig, 2),
      abBucketId = _ref$abConfig[0],
      abExperimentId = _ref$abConfig[1];

  return trackEvent_1({
    category: DEFAULT_CATEGORY,
    action: 'abExposure',
    label: stringify({
      abBucketId: abBucketId,
      abExperimentId: abExperimentId,
      qualifiedMessage: experimentId
    })
  });
};

var NOOP = function NOOP() {};

var loadScript = function loadScript(src) {
  var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP;
  var onerror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOOP;
  var script = document.createElement('script');
  script.src = src;
  script.onload = onload;
  script.onerror = onerror;
  script.async = false;
  document.body.appendChild(script);
};

var IMF_API_PATH = '/imf-fetch-message/api/v1/request/fetch-message/';

var MessageLoaderCore =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MessageLoaderCore, _React$Component);

  function MessageLoaderCore(props) {
    var _this;

    _classCallCheck(this, MessageLoaderCore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MessageLoaderCore).call(this, props));
    _this.state = {
      loaded: false,
      messageName: props.forceMessageName,
      messageProps: {},
      storeAssetManifest: {}
    };
    return _this;
  }

  _createClass(MessageLoaderCore, [{
    key: "callIMF",
    value: function callIMF() {
      var _this2 = this;

      /* eslint no-unused-vars: 0 */
      var _this$props = this.props,
          metroId = _this$props.metroId,
          pageName = _this$props.pageName,
          pageView = _this$props.pageView,
          referrer = _this$props.referrer;
      fetch("" + IMF_API_PATH + this.props.experimentId, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          CallerIdentifier: pageName,
          // retrieve message store manifest
          retrieveStoreManifest: true
        },
        body: JSON.stringify({
          metroId: metroId,
          localTimestamp: getLocalISODate(),
          pageName: pageName,
          pagePath: window.location.pathname,
          pageView: pageView,
          referrer: referrer,
          internalReferrer: document.referrer,
          connection: getConnectionData(),
          // pass ga data, this object is available through our gtm implementation
          gaData: global.ga_echo || getGAData()
        })
      }).then(function (r) {
        return r.json();
      }).then(function (_ref) {
        var treatmentName = _ref.treatmentName,
            renderData = _ref.renderData,
            storedManifest = _ref.storedManifest;

        _this2.setState({
          messageName: treatmentName,
          messageProps: renderData,
          storeAssetManifest: storedManifest || _this2.state.storeAssetManifest
        });

        _this2.loadAPI();
      })["catch"](function (e) {
        console.warn(e);
      });
    }
  }, {
    key: "getManifest",
    value: function getManifest() {
      var storeAssetManifest = this.state.storeAssetManifest; // We should return to this once ZOPS-48810 is resolved

      if (window.inBraavosPreviewer) {
        var apiPath = url.staticURL('/', 'static-messages-store');
        return fetch(apiPath + "rev-manifest.json?b=" + Date.now()).then(function (r) {
          return r.json();
        });
      }

      return new Promise(function (resolve, reject) {
        if (!isObjectEmpty(storeAssetManifest)) {
          resolve(storeAssetManifest);
        }

        reject();
      });
    }
  }, {
    key: "loadAPI",
    value: function loadAPI() {
      var _this3 = this;

      //TODO: Move to its own module
      var apiPath = url.staticURL('/', 'static-messages-store');

      var onScriptLoad = function onScriptLoad() {
        if (window.__Z__MESSAGE_STORE && typeof window.__Z__MESSAGE_STORE.load === 'function') {
          _this3.setState({
            loaded: true
          });
        } else {
          console.warn('Message Loader: Message Store has not initialized properly');
        }
      };

      var scriptPaths = {
        'overall-commons.js': 'overall-commons.js',
        'message-store/app.js': 'message-store/app.js',
        'versionHash': ''
      };

      if (!window.__Z__MESSAGE_STORE) {
        this.getManifest().then(function (data) {
          if (_typeof(data) === 'object' && data.hasOwnProperty('overall-commons.js') && data.hasOwnProperty('message-store/app.js')) {
            scriptPaths = _objectSpread({}, scriptPaths, data);
          } else {
            throw new Error('manifest does not have the required properties');
          }
        })["catch"](function (e) {
          console.warn("MessageLoader: Error retrieving/parsing manifest, falling back to default: " + e);
        })["finally"](function () {
          loadScript("" + apiPath + scriptPaths['overall-commons.js']);
          loadScript("" + apiPath + scriptPaths['message-store/app.js'], onScriptLoad);
        });
      } else {
        onScriptLoad();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          experimentId = _this$props2.experimentId,
          abConfig = _this$props2.abConfig;
      trackExposure({
        experimentId: experimentId,
        abConfig: abConfig
      }); // Initialize and call IMF

      if (abConfig[1] !== 'CONTROL') {
        if (!window.inBraavosPreviewer) {
          this.callIMF();
        } else {
          this.loadAPI();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          experimentId = _this$props3.experimentId,
          abConfig = _this$props3.abConfig;
      var loaded = this.state.loaded;

      if (this.props.pageView !== prevProps.pageView) {
        trackExposure({
          experimentId: experimentId,
          abConfig: abConfig
        });
      }

      if (this.props.reloadTimeStamp !== prevProps.reloadTimeStamp && loaded) {
        this.callIMF();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var experimentId = this.props.experimentId;
      var _this$state = this.state,
          loaded = _this$state.loaded,
          messageName = _this$state.messageName,
          messageProps = _this$state.messageProps,
          storeAssetManifest = _this$state.storeAssetManifest;
      var versionHash = storeAssetManifest && storeAssetManifest.versionHash || '';
      var renderedMessageName = this.props.forceMessageName || messageName; //TODO: abstract this out into module instead of referencing the window object directly

      var MessageComponent = loaded && renderedMessageName ? window.__Z__MESSAGE_STORE.load(renderedMessageName, _objectSpread({}, messageProps, {
        experimentId: experimentId,
        treatmentName: renderedMessageName,
        treatmentVersion: versionHash
      })) : function () {
        return null;
      };
      return React.createElement("div", null, React.createElement(MessageComponent, null));
    }
  }]);

  return MessageLoaderCore;
}(React.Component);

MessageLoaderCore.propTypes = process.env.NODE_ENV !== "production" ? {
  abConfig: PropTypes.arrayOf(PropTypes.string),
  experimentId: PropTypes.string,
  forceMessageName: PropTypes.string,
  guid: PropTypes.string,
  metroId: PropTypes.number,
  pageName: PropTypes.string,
  pageView: PropTypes.number,
  referrer: PropTypes.string,
  reloadTimeStamp: PropTypes.number
} : {};
MessageLoaderCore.defaultProps = {
  abConfig: ['ADT_PROGRESSIVE_MESSAGE', 'TOP_SLOT'],
  experimentId: 'ACT_SRP_TOP',
  // MOBILE_APP_UPSELL for app-upsell
  forceMessageName: '',
  metroId: 0,
  pageView: 0,
  referrer: ''
};

var MessageLoader = function MessageLoader(props) {
  return React.createElement(reactErrorBoundary.ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return null;
    }
  }, React.createElement(MessageLoaderCore, props));
};

module.exports = MessageLoader;



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/message-loader/lib/index.js
// module id = 502
// module chunks = 1